import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  keyPwd = "zKW!Z%m7^QGG%VDJ";

  constructor() { }

    /**
   * Method to encrypt data
   * @param password 
   * @returns 
   */
  encrypt(password: string): string {
    return CryptoJS.AES.encrypt(password, this.keyPwd).toString();
  }

    /**
   * Method to decrypt data
   * @param password 
   * @returns 
   */
  public decrypt(passwordToDecrypt: string) {
      return CryptoJS.AES.decrypt(passwordToDecrypt, this.keyPwd).toString(CryptoJS.enc.Utf8);
  }
}
